export default "__VITE_ASSET__CmknugL9__"